import React, { useEffect } from 'react'
import { RouteComponentProps, useLocation, useHistory } from 'react-router-dom';
import { useGlobal, useDispatch } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import { WhatsNew } from '../../models/whatsNew';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import WhatsNewEdit from './edit';

type PageEditWhatsNewProps = RouteComponentProps<any>;

export const WhatsNewDetail = (props: PageEditWhatsNewProps) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [currentEditWhatsNew] = useGlobal<IGlobalState, 'currentEditWhatsNew'>('currentEditWhatsNew');
    const oidIndex = location.pathname.lastIndexOf('/')
    const oid = parseInt(location.pathname.substring(oidIndex + 1))
    
    //TODO
    console.log('WhatsNew id is: ' + oid);
    const whatsNew = currentEditWhatsNew?.whatsNew;

    useEffect(() => {
        // Il seguente è per non eseguire cambio di pagina durante il render
        if(!whatsNew) 
            history.push('/whatsNew');
    }, [whatsNew, history])

    const initialMode = oid > 0 ? InEditingMode.Edit : InEditingMode.New;
    return ( 
        <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
            <IForfettariAppBar title="WhatsNew" handleLoad={() => {}}></IForfettariAppBar>
            <Main>
                <WhatsNewEdit initialMode={initialMode} /> 
            </Main>
        </div>    
    )
}




